export default __webpack_public_path__ + "static/media/pdf-icon.f9fcad0d.svg";